export default "__VITE_ASSET__CgKHM4IG__"